import { JSX } from 'react'

import Title from './Title'
import ButtonMenu from '../../ButtonMenu'

import * as S from './styles'

interface EditStyleModalProps {
  name: string
  contentHTML: JSX.Element
  allowSubmitBtn?: boolean
  confirmCallback: () => void
  cancelCallback: () => void
  confirmText?: string
}

const EditStyleModal = ({
  name,
  contentHTML,
  allowSubmitBtn = true,
  confirmCallback,
  cancelCallback,
  confirmText
}: EditStyleModalProps) => {
  return (
    <S.EditInfoModalContainer>
      <Title name={name} cancelCallback={cancelCallback} />

      {contentHTML}

      <ButtonMenu
        cancelCallback={cancelCallback}
        confirmCallback={confirmCallback}
        confirmText={confirmText}
        allowSubmitBtn={allowSubmitBtn}
      />
    </S.EditInfoModalContainer>
  )
}

export default EditStyleModal
